import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=9e3bf4b6"
import script from "./badge.vue?vue&type=script&setup=true&lang=js"
export * from "./badge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./badge.vue?vue&type=style&index=0&id=9e3bf4b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports